module.exports = __webpack_public_path__ + "img/dcpthgz-bg.151cad78.png";